import { render } from "./ClientDetailsPage.vue?vue&type=template&id=78cd603e"
import script from "./ClientDetailsPage.vue?vue&type=script&lang=js"
export * from "./ClientDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__